import { render, staticRenderFns } from "./PortailGroupe.vue?vue&type=template&id=4f7e779c"
import script from "./PortailGroupe.vue?vue&type=script&lang=js"
export * from "./PortailGroupe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports